<template>
  <div class="accommodationwrapper">

    <Loading :show="!webpools.length" />

    <div :class="'admin-table-wrapper ' + (pool.active ? 'open' : 'closed')" v-for="(pool, index) in pools" v-bind:key="index">
      <h2><a href="#" @click.stop.prevent="pool.active = !pool.active">{{pool.display_name || pool.name}}</a></h2>
      <table class="admin-table" style="margin-bottom:10px;" v-if="pool.active">
        <tbody>
          <tr v-if="index">
            <td>
              <table class="vertical-table">
                <tr>
                  <th>
                    Namn (visas om inte visningsnamn är ifyllt, kan inte ändras härifrån)
                  </th>
                  <td>
                    <input class="large" disabled readonly v-model="pool.name" />
                  </td>
                </tr>
                <tr>
                  <th>
                    Visningsnamn (visas om ifyllt)
                  </th>
                  <td>
                    <input class="large" @change="updatePool(pool, 'visningsnamn')" v-model="pool.display_name" />
                  </td>
                </tr>
                <tr>
                  <th>
                    Videolänk (Vimeo)
                  </th>
                  <td>
                    <input class="large" @change="updatePool(pool, 'video')" v-model="pool.video"  />
                  </td>
                </tr>
                <tr>
                  <th>
                    Kartlänk (PDF)
                  </th>
                  <td>
                    <input class="large" @change="updatePool(pool, 'karta')" v-model="pool.map_link"  />
                  </td>
                </tr>
                <tr>
                  <th>
                    Dölj karta
                  </th>
                  <td>
                    <label>
                      <input type="checkbox" @change="updatePool(pool, 'kartvisning')" v-model="pool.hide_map" /> Dölj karta
                    </label>
                  </td>
                </tr>
                <tr>
                  <th>
                    Beskrivning
                  </th>
                  <td>
                    <textarea rows="6" class="large" @change="updatePool(pool, 'beskrivning')" v-model="pool.short_description" />
                  </td>
                </tr>
                <tr>
                  <th>
                    Punkter (en ny punkt per rad)
                  </th>
                  <td>
                    <textarea rows="6" class="large" @change="updatePool(pool, 'USP-punkter')" v-model="pool.bullet_points" />
                  </td>
                </tr>
                <tr>
                  <th>
                    Bildlänk – stor bild
                  </th>
                  <td>
                    <input class="large" @change="updatePool(pool, 'stor bild')" v-model="pool.image" />
                    <img class="image-preview" :src="pool.image" />
                  </td>
                </tr>
                <tr>
                  <th>
                    Bildlänk – miniatyrbild
                  </th>
                  <td>
                    <input class="large" @change="updatePool(pool, 'minitiatyrbild')" v-model="pool.image_thumbnail" />
                    <img class="image-preview" :src="pool.image_thumbnail" />
                  </td>
                </tr>
                <tr>
                  <th>
                    Incheckningstid
                  </th>
                  <td>
                    <input @change="updatePool(pool, 'incheckningstid')" v-model="pool.check_in_time" />
                  </td>
                </tr>
                <tr>
                  <th>
                    Utcheckningstid
                  </th>
                  <td>
                    <input @change="updatePool(pool, 'utcheckningstid')" v-model="pool.check_out_time" />
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="admin-table" v-if="pool.active">
        <tbody>
          <tr class="header">
            <th>
              #
            </th>
            <th>
              Visa webb
            </th>
            <th>
              Namn 1
            </th>
            <th>
              Namn 2
            </th>
            <th>
              Visningsnamn
            </th>
            <th>
              Kort beskrivning / Nattförvaring
            </th>
            <th>
              Antal kvar / Ankomst
            </th>
            <th>
              Bildlänk
            </th>
            <th>
              Område
            </th>
            <th>
              Tider
            </th>
          </tr>
          <tr v-for="(unit, index) in pool.units" v-bind:key="index">
            <td>
              #{{unit.id}}
            </td>
            <td>
              <input type="checkbox" disabled v-model="unit.show_web" /> 
              <a v-if="unit.show_web" href="#" @click.stop.prevent="openUnit(unit)" target="_blank"> Visa </a>
              <span v-if="!unit.show_web"> Visa</span>
            </td>
            <td>
              {{unit.name}}
            </td>
            <td>
              {{unit.description_title}}
            </td>
            <td>
              <input @change="updateUnit(unit, 'namn')" v-model="unit.display_name"  />
            </td>
            <td>
              <input @change="updateUnit(unit, 'beskrivning')" v-model="unit.subtitle" />
              <label>
                <input type="checkbox" @change="updateUnit(unit, 'nattförvaring')" v-model="unit.night_storage" /> Nattförvaring
              </label>
              <label>
                <input type="checkbox" @change="updateUnit(unit, 'obl. slutstäd')" v-model="unit.has_mandatory_cleaning" /> Obl. slutstäd
              </label>
            </td>
            <td>
              <label>
                <input type="checkbox" @change="updateUnit(unit, 'visning av antal kvar')" v-model="unit.use_unit_count" /> Visa antal kvar
              </label>
              <label>
                <select @change="updateUnit(unit, 'pristyp')" v-model="unit.price_type">
                  <option v-for="i in ['thursday', 'saturday']" :key="i" :value="i">
                    {{
                      {
                        thursday: '-',
                        saturday: 'Lördag',
                      }[i]
                    }}
                  </option>
                </select>
              </label>
            </td>
            <td>
              <input @change="updateUnit(unit, 'bild')" v-model="unit.image"  />
            </td>
            <td>
              <select @change="updateUnit(unit, 'områdestillhörighet')" v-model="unit.webpool_id">
                <option v-for="p in webpools" v-bind:key="p.id" :value="p.id">
                  {{p.display_name || p.name}}
                </option>
              </select>
            </td>
            <td>
              <input @change="updateUnit(unit, 'incheckning')" v-model="unit.check_in_time"  /><br />
              <input @change="updateUnit(unit, 'utcheckning')" v-model="unit.check_out_time"  />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import API from '@/classes/API';
import Loading from '@/components/components/Loading';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      pools: [],
      webpools: [],
    };
  },
  async mounted() {
    const { data, pools } = await API.get('/grouped?all=1');
    this.pools = data;
    this.webpools = pools;
  },
  computed: {
  },
  methods: {
    /*eslint-disable */
    capitalizeFirstLetter(string) {
      try {
        return string.charAt(0).toUpperCase() + string.slice(1);
      } catch (e) {
        return string;
      }
    },
    /*eslint-enable */
    updatePool(pool, what = '') {
      API.post('/admin/update-pool', {
        id: pool.id,
        display_name: pool.display_name,
        image: pool.image,
        image_thumbnail: pool.image_thumbnail,
        video: pool.video,
        hide_map: pool.hide_map,
        map_link: pool.map_link,
        short_description: pool.short_description,
        bullet_points: pool.bullet_points,
        check_in_time: pool.check_in_time,
        check_out_time: pool.check_out_time,
      });

      /*eslint-disable */
      what = this.capitalizeFirstLetter(what);
      this.$toast.success((what + ' för ' + (pool.display_name || pool.name) + ' uppdaterades'), 'Område uppdaterat', {
        position: 'topRight',
      });
      /*eslint-enable */
    },
    updateUnit(unit, what = '') {
      API.post('/admin/update-unit', {
        id: unit.id,
        display_name: unit.display_name,
        subtitle: unit.subtitle,
        image: unit.image,
        use_unit_count: unit.use_unit_count,
        webpool_id: unit.webpool_id,
        check_in_time: unit.check_in_time,
        check_out_time: unit.check_out_time,
        price_type: unit.price_type,
        night_storage: unit.night_storage,
        has_mandatory_cleaning: unit.has_mandatory_cleaning,
      });

      /*eslint-disable */
      what = this.capitalizeFirstLetter(what);
      this.$toast.success((what + ' för ' + (unit.display_name || unit.description_title) + ' uppdaterades'), 'Enhet uppdaterad', {
        position: 'topRight',
      });
      /*eslint-enable */
    },
    openUnit(unit) {
      const link = this.$router.resolve(`/boenden/info/${unit.slug}`);
      window.open(link.href, '_blank');
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.accommodationwrapper
  admin-container()

.admin-table-wrapper
  margin-bottom 50px
  padding 20px
  transition: all 0.2s
  label
    font-weight inherit
  &.closed
    margin-bottom: 0
    padding 0 20px
    h2
      font-size: 1em
      font-weight normal
      font-family: Interstate
  .admin-table
    width 100%
    th, td
      vertical-align: top
    input
      font-weight 300
      padding 3px 4px
      margin 2px
      border 1px solid lightgrey
      &.large
        width 100%
        min-width: 800px
    tbody 
      background-color: silver-light
      th
        background-color deep-sea-blue
        color white
      tr
        border 1px solid light-blue-grey
        &:nth-child(odd)
          td
            background-color: pale-grey
  .vertical-table
    tr
      border 1px solid rgba(125, 125, 125 0.5) !important
      th, td
        vertical-align: top
        padding 15px
      td
        background-color: white !important

th, td
  text-align left
  padding 2px 5px
  input
    font-weight normal
tbody tr:last-child td
  padding-bottom 20px
input
  pading 2px 5px

.image-preview
  max-height 100px
</style>



// WEBPACK FOOTER //
// Accomodation.vue?204a855a